import React, { useContext } from 'react';
import { AppCtx } from '../../../AppCtx';
import { useSongContentService } from '../../song/hooks/useSongContentService';

/**
 * Button to toggle the expansion/collapse of all songs
 * Performs the same action as pressing the 'l' key
 */
const ToggleAllSongsExpansionButtonComponent = () => {
  const { selectedFile, collapsedSongs, setCollapsedSongs } = useContext(AppCtx);
  const { songsJson } = useSongContentService();

  const toggleAllSongsExpansion = () => {
    if (!selectedFile?.name) return;
    
    setCollapsedSongs(prev => {
      const newMap = new Map(prev);
      const fileCollapsed = newMap.get(selectedFile.name) || new Set();
      
      // If no songs are collapsed or not all are collapsed, collapse all
      // Otherwise, expand all
      if (fileCollapsed.size === 0 || fileCollapsed.size < (songsJson?.songs?.length || 0)) {
        newMap.set(selectedFile.name, new Set(Array.from({ length: songsJson.songs.length }, (_, i) => i)));
      } else {
        newMap.set(selectedFile.name, new Set());
      }
      
      return newMap;
    });
  };

  // Determine if all songs are collapsed to show the appropriate icon
  const fileCollapsedSongs = collapsedSongs.get(selectedFile?.name) || new Set();
  const areAllSongsCollapsed = songsJson?.songs?.length > 0 && fileCollapsedSongs.size === songsJson.songs.length;

  return (
    <div
      onClick={toggleAllSongsExpansion}
      style={{cursor:'pointer', borderRadius:'30%', padding:'5px'}}
      role="button" tabIndex={0}
      aria-label={areAllSongsCollapsed ? "Rozwiń wszystkie piosenki" : "Zwiń wszystkie piosenki"}
      title={areAllSongsCollapsed ? "Rozwiń wszystkie piosenki" : "Zwiń wszystkie piosenki"}
    >
      <span style={{fontSize: '16px', color: 'var(--menu-icon-color)'}}>
        {areAllSongsCollapsed ? '📕' : '📖'}
      </span>
    </div>
  );
};

export default ToggleAllSongsExpansionButtonComponent;
